/**
 * `/me` may return `profile_image` as a URL string or as `{ src, sizes }`.
 * UI and `<img src>` expect a string URL.
 */
export function profileImageUrlFromApiValue(value: unknown): string | undefined {
  if (value == null) return undefined
  if (typeof value === 'string') {
    const trimmed = value.trim()
    return trimmed === '' ? undefined : trimmed
  }
  if (typeof value === 'object' && value !== null && 'src' in value) {
    const src = (value as { src?: unknown }).src
    if (typeof src === 'string' && src.trim() !== '') return src
  }
  return undefined
}
